var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bg-white shadow-lg pt-5 pb-3 my-3",staticStyle:{"border-radius":"20px"}},[_c('div',{attrs:{"id":_vm.chart_id}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }